import { createMiddleware } from "@tanstack/react-start"

import { getSupabaseServerClient } from "@repo/supabase/server-client"

export const supabaseServerClientMiddleware = createMiddleware({
  type: "function",
}).server(async ({ next }) => {
  const supabase = getSupabaseServerClient()

  return next({
    context: {
      supabase,
    },
  })
})
